import GlobalVariable from '@/global/global-variable'
import ApiFileLocal from './api-file-local.js'

// 查询车辆
const searchCarApi = GlobalVariable.BASE_PATH + "/rest/car/search";

// 查询绑定车辆的标签
const findBindingApi = GlobalVariable.BASE_PATH + "/rest/car/findBinding";

// 添加车辆
const addCarApi = GlobalVariable.BASE_PATH + "/rest/car/add";

// 修改车辆
const updateCarApi = GlobalVariable.BASE_PATH + "/rest/car/update";

// 删除车辆
const deleteCarApi = GlobalVariable.BASE_PATH + "/rest/car/delete";

// 绑定
const bindingCarApi = GlobalVariable.BASE_PATH + "/rest/car/binding";
// 解除绑定
const unboundCarApi = GlobalVariable.BASE_PATH + "/rest/car/unbound";

// 上传解析
const uploadUrlApi = GlobalVariable.BASE_PATH + "/rest/car/upload";

// 数据导出
const exportApi = GlobalVariable.BASE_PATH + "/rest/car/export";

// 查询车辆组
const searchCarGroupApi = GlobalVariable.BASE_PATH + "/rest/car/group/search";

// 添加车辆组
const addCarGroupApi = GlobalVariable.BASE_PATH + "/rest/car/group/add";

// 修改车辆组
const updateCarGroupApi = GlobalVariable.BASE_PATH + "/rest/car/group/update";

// 删除车辆组
const deleteCarGroupApi = GlobalVariable.BASE_PATH + "/rest/car/group/delete";


export default {
    // 查询车辆
    searchCarApi,
    // 查询绑定的车辆标签
    findBindingApi,
    // 添加车辆
    addCarApi,
    // 修改车辆
    updateCarApi,
    // 删除车辆
    deleteCarApi,
    // 绑定
    bindingCarApi,
    // 解除绑定
    unboundCarApi,
    // 上传解析
    uploadUrlApi,
    // 导出数据
    exportApi,
    // 车辆上传模板
    carUploadModel: ApiFileLocal.file_car_upload_model,
    // 查询车辆组
    searchCarGroupApi,
    // 添加车辆组
    addCarGroupApi,
    // 修改车辆组
    updateCarGroupApi,
    // 删除车辆组
    deleteCarGroupApi

}



// WEBPACK FOOTER //
// ./src/request/api-car.js